import { useContext } from 'react'

import { AprovacaoContext } from '@provider/FollowUpFornecedor/AprovacaoProvider'

import { IAprovacaoContext } from '@base/@types/providers/FollowUpFornecedor/AprovacaoProvider'

export default function useFollowUpAprovacao(): IAprovacaoContext {
  return useContext(AprovacaoContext)
}
